import instance from './axios';

export const getHomeBanner = (params = {}) => instance.get('/app-api/promotion/banner/list', { params });
export const articleLists = (params = {}) => instance.get('/app-api/promotion/article/page', { params } );
export const articleDetail = (params = {}) => instance.get('/app-api/promotion/article/get', { params } );

export const spuLists = (params = {}) => instance.get('/app-api/product/spu/page', { params } );
export const spuDetail = (params = {}) => instance.get('/app-api/product/spu/get-detail', { params } );


export const classification = (params = {}) => instance.get('/app-api/museum/antique/classification', { params } );
export const antiqueLists = (params = {}) => instance.get('/app-api/museum/antique/page', { params } );
export const antiqueDetail = (params = {}) => instance.get('/app-api/museum/antique/get', { params } );
export const getHeritageLists = (params = {}) => instance.get('/app-api/museum/cultural-heritage/page', { params } );
export const getHeritageDetail = (params = {}) => instance.get('/app-api/museum/cultural-heritage/get?id=' + params.id );

export const exhibitLists = (params = {}) => instance.get('/app-api/museum/exhibit/page', { params } );
export const exhibitDetail = (params = {}) => instance.get('/app-api/museum/exhibit/get', { params } );

export const messagePageGet = (params = {}) => instance.get('/app-api/museum/message/page', { params } );
export const messageCreate = (data = {}) => instance.post('/app-api/museum/message/create', data);
export const addPV = () => instance.post('/app-api/infra/pv-statistics/add');
// 获取验证图片  以及token
export function reqGet (data) {
    return instance({
        url: '/app-api/system/captcha/get',
        method: 'post',
        data
    });
}

// 滑动或者点选验证
export function reqCheck (data) {
    return instance({
        url: '/app-api/system/captcha/check',
        method: 'post',
        data
    });
}
